import './CodeSnippet.scss';
import SyntaxHighlighter from 'react-syntax-highlighter';
import darkTheme from 'react-syntax-highlighter/dist/esm/styles/hljs/atom-one-dark';
import { formatXML } from '../../constants/apiUtil';


const CodeSnippet = ({ children }) => {
  const formattedXML = formatXML(children, '    ').trim()
  return (
    <div className="code-container">
      <button className='code-snippet-buttons' aria-label="Copy input data" data-code={formattedXML}>{'Copy'}</button>
      <SyntaxHighlighter language="xml" style={darkTheme} showLineNumbers>{formattedXML}</SyntaxHighlighter>
    </div>
  );
};

export default CodeSnippet;
